import { FC } from 'react';

import Drawer from '@material-ui/core/Drawer';
import { makeStyles } from '@material-ui/core/styles';

import SuperAdminOpportunitiesFiltersNew from './SuperAdminOpportunitiesFiltersNew';

const useStyles = makeStyles({
	paper: {
		zIndex: 99,
	},
});

type SuperAdminOpportunitiesSidebarNewProps = {
	open: boolean;
	onClose: () => void;
	enableOrganizationFilter: boolean;
};

const SuperAdminOpportunitiesSidebarNew: FC<SuperAdminOpportunitiesSidebarNewProps> = ({
	open,
	onClose,
	enableOrganizationFilter,
}: SuperAdminOpportunitiesSidebarNewProps) => {
	const classes = useStyles();

	return (
		<Drawer
			anchor="right"
			variant="persistent"
			classes={{
				paper: classes.paper,
			}}
			open={open}
			onClose={onClose}
		>
			<SuperAdminOpportunitiesFiltersNew enableOrganizationFilter={enableOrganizationFilter} onClose={onClose} />
		</Drawer>
	);
};

export default SuperAdminOpportunitiesSidebarNew;
